
import sulu from 'razlet-sulu-sdk/lib/mixins/sulu';

export default {
  name: 'passengers-page',
  mixins: [sulu],
};
